<template>
  <div>
    <a-layout>
      <a-layout-sider :width="200" breakpoint="md" collapsible theme="light">
        <a-spin :spinning="loadingParent">
          <a-menu mode="inline" style="min-height: 70px;" @select="seleccionarMenu">
            <a-menu-item key="DATOSPERSONALES" v-if="roles.permiso_bloque_1 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="idcard"/>
              <span>{{$t('Identificación')}} </span>
            </a-menu-item>
            <a-menu-item key="CLIENTE" v-if="roles.permiso_bloque_13 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="user"/>
              <span>{{$t('Cliente')}} </span>
            </a-menu-item>
            <a-menu-item key="CARGUEDOCUMENTACION" v-if="roles.permiso_bloque_3 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="cloud-upload"/>
              <span>{{$t('Carpeta')}}</span>
            </a-menu-item>
            <a-menu-item key="DATOSFAMILIARES" v-if="roles.permiso_bloque_4 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="team"/>
              <span>{{$t('Familia')}} </span>
            </a-menu-item>
            <a-menu-item key="OTROSDATOSFAMILIARES" v-if="roles.permiso_bloque_5 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="warning"/>
              <span>{{$t('Emergencia')}} </span>
            </a-menu-item>
            <a-menu-item key="INFORMACIONACADEMICA" v-if="roles.permiso_bloque_6 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="read"/>
              <span>{{$t('Academia')}} </span>
            </a-menu-item>
            <a-menu-item key="IDIOMAOTROSESTUDIOS" v-if="roles.permiso_bloque_8 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="book"/>
              <span>{{$t('Formación')}} </span>
            </a-menu-item>
            <a-menu-item key="REFERENCIAS" v-if="roles.permiso_bloque_7 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="contacts"/>
              <span>{{$t('Referencias')}} </span>
            </a-menu-item>
            <a-menu-item key="INFORMACIONLABORAL" v-if="roles.permiso_bloque_11 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="audit"/>
              <span>{{$t('Experiencia')}} </span>
            </a-menu-item>
            <a-menu-item key="INFORMACIONBANCARIA" v-if="roles.permiso_bloque_10 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="wallet"/>
              <span>{{$t('Banco')}} </span>
            </a-menu-item>
            <a-menu-item key="OTROSDATOSPERSONALES" v-if="roles.permiso_bloque_2 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="car"/>
              <span>{{$t('Conducción')}}</span>
            </a-menu-item>
            <a-menu-item key="OTRAINFORMACIONLABORAL" v-if="roles.permiso_bloque_9 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="reconciliation"/>
              <span>{{$t('Adicionales')}} </span>
            </a-menu-item>
            <a-menu-item key="FORMULARIOS" v-if="roles.permiso_bloque_12 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="profile"/>
              <span>{{$t('Formularios')}} </span>
            </a-menu-item>
            <a-menu-item key="FIRMAS" v-if="roles.permiso_bloque_15 && !$isEmpty(personaSeleccioanda)">
              <a-icon type="highlight"/>
              <span>{{$t('Firma Documentos')}} </span>
            </a-menu-item>
            <a-menu-item key="FINALIZACIONINGRESODATOS" v-if="roles.permiso_bloque_14 &&
                                                              !$isEmpty(personaSeleccioanda) &&
                                                              $getConfigValue('BIODATA_VER_OPCION_FINALIZAR_INGRESO_DATOS', 'NO') === 'SI'">
              <a-icon type="history"/>
              <span>{{$t('Finalizar')}} </span>
            </a-menu-item>
          </a-menu>
        </a-spin>
      </a-layout-sider>
      <a-layout-content>
        <!--        <a-row :gutter="[16,16]" style="margin: 5px">-->
        <!--          <a-col v-if="menuActivo != menu.datosPersonales" :md="24" :xs="24">-->
        <!--            <a-spin :spinning="loading">-->
        <!--              <biodata-resumen :tamanoimg="100" :persona="persona">-->
        <!--              </biodata-resumen>-->
        <!--            </a-spin>-->
        <!--          </a-col>-->
        <!--        </a-row>-->
        <a-row :gutter="[16,16]" style="margin: 5px" id="test">
          <a-col :md="puedeCrear?12:24" :xs="24">
            <a-spin :spinning="loading">
              <biodata-resumen :tamanoimg="81" :persona="persona">
              </biodata-resumen>
            </a-spin>
          </a-col>
          <a-col :span="24" :md="12" :xs="24" v-if="puedeCrear">
            <a-spin :spinning="loading">
              <a-form :form="form">
                <a-card>
                  <a-form :form="form">
                    <a-row :gutter="[12,12]">
                      <g-lookup :label="$t('Buscar Persona')"
                                :formItemConfig="{
                            'label-col': {},
                            'wrapper-col': {},
                            'has-feedback': false
                          }"
                                endpoint="personas"
                                ref="persona"
                                :decorator="['identificacion']"
                                @change="personaCambiada">
                      </g-lookup>
                      <biodata-crear-persona @success="personaCreada"></biodata-crear-persona>
                    </a-row>
                  </a-form>
                </a-card>
              </a-form>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.datosPersonales && roles.permiso_bloque_1">
            <biodata-datos-personales :persona="personaSeleccioanda"></biodata-datos-personales>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.otrosdatosPersonales && roles.permiso_bloque_2">
            <biodata-conduccion :persona="personaSeleccioanda"></biodata-conduccion>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.carguedocumentacion && roles.permiso_bloque_3">
            <biodata-cargue-documentacion :persona="personaSeleccioanda"></biodata-cargue-documentacion>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.datosfamiliares && roles.permiso_bloque_4">
            <biodata-datos-familiares :persona="personaSeleccioanda"></biodata-datos-familiares>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.otrosdatosfamiliares && roles.permiso_bloque_5">
            <biodata-otros-datos-familiares :persona="personaSeleccioanda"></biodata-otros-datos-familiares>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.informacionacademica && roles.permiso_bloque_6">
            <biodata-informacion-academica :persona="personaSeleccioanda"></biodata-informacion-academica>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.referencias && roles.permiso_bloque_7">
            <biodata-referencias :persona="personaSeleccioanda"></biodata-referencias>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.idiomaotrosestudios && roles.permiso_bloque_8">
            <biodata-idioma-otros-estudios :persona="personaSeleccioanda"></biodata-idioma-otros-estudios>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.otrainformacionlaboral && roles.permiso_bloque_9">
            <biodata-otra-informacion-laboral
              :persona="personaSeleccioanda"></biodata-otra-informacion-laboral>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.informacionbancaria && roles.permiso_bloque_10">
            <biodata-informacion-bancaria :persona="personaSeleccioanda"></biodata-informacion-bancaria>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.informacionlaboral && roles.permiso_bloque_11">
            <biodata-informacion-laboral :persona="personaSeleccioanda"></biodata-informacion-laboral>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.forularios && roles.permiso_bloque_12">
            <biodata-otros-formularios :persona="personaSeleccioanda"></biodata-otros-formularios>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.cliente && roles.permiso_bloque_13">
            <biodata-cliente :persona="personaSeleccioanda"></biodata-cliente>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.finalizacioningresodatos &&
                                  roles.permiso_bloque_14 &&
                                  $getConfigValue('BIODATA_VER_OPCION_FINALIZAR_INGRESO_DATOS', 'NO') === 'SI'">
            <biodata-finalizar-ingreso-datos :persona="personaSeleccioanda"></biodata-finalizar-ingreso-datos>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.firmaDocumentos && roles.permiso_bloque_15">
            <sign-pdf></sign-pdf>
          </a-col>
        </a-row>
      </a-layout-content>
    </a-layout>


    <a-modal :visible="isPoliticsVisible"
             title="Políticas de la empresa"
             :cancel-button-props="{props: { disabled: true } }"
             :ok-button-props="{props: { disabled: politicState } }"
             :closable="false"
             :maskClosable="false"
             @ok="changeStatePolitics"
    >
      <a-spin :spinning="loadingPolitics">
        <a-row :gutter="[16,16]">
          <a-col>
		<div v-html="$getConfigValue('POLITICAS_BIODATA', 'Parámetro POLITICAS_BIODATA no configurado')"></div>
          </a-col>
          <a-col>
            <a-checkbox @change="politicsChange">
              Para continuar debes aceptar las políticas.
            </a-checkbox>
          </a-col>
        </a-row>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import UserUtil from 'CustomModules/GlobalBPOCore/Util/UserUtil'

  export default {
    data () {
      return {
        text: 'Autorizo a ' + UserUtil.getConfigValue('EMP_NAME_COMPANY') + ' de manera previa, voluntaria, expresa, ' +
          'libre, inequívoca e informada, para dar tratamiento a la mis datos personales, incluyendo datos sensibles como biométricos, ' +
          'georreferenciación, registros fílmicos, fotografías, médicos y demás datos que puedan llegar a ser ' +
          'considerados como sensibles, los cuales se utilizarán para la validación de titularidad e identidad, ' +
          'para seguimiento de rutas comerciales, seguridad de los activos de información, controles de acceso, ' +
          'seguridad física, para control médico realizado exclusivamente por el médico laboral y dar cumplimiento a ' +
          'requerimientos de entidades gubernamentales en caso de ser solicitados, de conformidad con la Ley ' +
          'Estatutaria 1581 de 2012, el Decreto 1377 de 2013 y demás normas que los modifiquen y/o adicionen y/o ' +
          'sustituyan, sobre Protección de Datos Personales. Estos datos personales podrán ser recolectados, ' +
          'almacenados, procesados, usados, suprimidos, actualizados y transmitidos mediante los canales de ' +
          'comunicación previstos por ' + UserUtil.getConfigValue('EMP_NAME_COMPANY') +
          ' (físicos, digitales, medios magnéticos, aplicativos tecnológicos y otros), también para las siguientes ' +
          'finalidades: (i) procesos de reclutamiento, selección y ' +
          'archivo para efectos estadísticos; (ii) realizar directamente o a través de terceros consultas en las ' +
          'listas inhibitorias o restrictivas y bases de datos de la Procuraduría, Contraloría, CIFIN, Data Crédito, ' +
          'verificación de antecedentes, pruebas y exámenes de ingreso; (iii) gestionar el proceso de contratación y ' +
          'dar cumplimiento a las obligaciones contractuales; (iv) dar cumplimiento a las obligaciones legales y ' +
          'contractuales; (v) dar cumplimiento a la legislación laboral, de seguridad social, salud ocupacional y ' +
          'demás disposiciones referentes a temas laborales, actividades culturales, programas de bienestar y ' +
          'capacitaciones; (vi) afiliación a las diferentes entidades del Sistema General de Seguridad Social y ' +
          'Parafiscales; (vii) incentivar la participación en programas de Desarrollo, Bienestar Organizacional o ' +
          'campañas de endomarketing; (viii) Dejar registro fílmico y escrito de actividades de capacitación o bienestar; ' +
          '(ix) gestionar controles de ingreso y retiro de instalaciones; (x) gestión de pagos y descuentos, incluidas ' +
          'las novedades o autorizaciones que el colaborador da a entidades terceras para descuentos por nómina; ' +
          '(xi) dar cumplimiento a requerimientos de Ley; y (xii) procesos administrativos para la gestión del recurso ' +
          'humano, clima laboral y ambiente de trabajo; conforme a los términos y condiciones señalados en la Ley 1581 ' +
          'de 2012, sus decretos reglamentarios y en armonía con la política de tratamiento de datos personales de ' +
          UserUtil.getConfigValue('EMP_NAME_COMPANY') + ', la cual puedo consultar en la página web www.coexito.com.co. ' +
          '<br>' + '<br>' +
          'En relación con los datos personales de terceros que suministro, declaro y garantizo que cuento con la ' +
          'autorización del / los titulares para suministrar sus datos de identificación y ubicación, y que podrán ser ' +
          'contactados con las finalidades de verificación de la información proporcionada por el suscrito en este' +
          ' documento y para actualizar la información a futuro. Así mismo, me comprometo a informar y actualizar ' +
          'cualquier novedad que se presente con mis datos personales, familiares o académicos; por cuanto, declaro ' +
          'que la información suministrada en este documento es veraz, completa, exacta, actualizada, comprobable y ' +
          'comprensible. De igual forma, será mi responsabilidad mantener la información actualizada de forma que ' +
          'responda en cada momento a mi situación real y de mi grupo familiar. En todo caso, yo seré el único ' +
          'responsable de las manifestaciones falsas o inexactas que realice y de los perjuicios que cause a mi ' +
          'empleador o a terceros por la información que facilite.' +
          '<br>' + '<br>' +
          'Reconozco que como titular de la información puedo ejercer los derechos mencionados, dirigiendo una ' +
          'petición en este sentido a la dirección electrónica protecciondedatospersonales@coexito.com.co, ' +
          'conforme a lo establecido en la política de tratamiento de datos de ' + UserUtil.getConfigValue('EMP_NAME_COMPANY') +
          ', la cual puedo consultar en la página web www.coexito.com.co.' +
          '<br>' + '<br>' +
          'El suscrito manifiesto que he leído y comprendido a cabalidad el contenido de este documento, acepto las ' +
          'finalidades aquí descritas, las consecuencias y alcance de estas. Esta autorización permanecerá vigente, ' +
          'hasta que sea revocada o hasta que se agoten las finalidades para las que se otorgó y podrá revocarse en ' +
          'los eventos previstos en la Ley.',
        isPoliticsVisible: false,
        loadingParent: false,
        biodata_politicas_desactivadas: this.$getConfigValue('BIODATA_POLITICAS_DESACTIVADAS', 'NO') === 'SI',
        roles: {
          permiso_bloque_1: this.$userIsInrol('BIODATA_BLOQUE_1'),
          permiso_bloque_2: this.$userIsInrol('BIODATA_BLOQUE_2'),
          permiso_bloque_3: this.$userIsInrol('BIODATA_BLOQUE_3'),
          permiso_bloque_4: this.$userIsInrol('BIODATA_BLOQUE_4'),
          permiso_bloque_5: this.$userIsInrol('BIODATA_BLOQUE_5'),
          permiso_bloque_6: this.$userIsInrol('BIODATA_BLOQUE_6'),
          permiso_bloque_7: this.$userIsInrol('BIODATA_BLOQUE_7'),
          permiso_bloque_8: this.$userIsInrol('BIODATA_BLOQUE_8'),
          permiso_bloque_9: this.$userIsInrol('BIODATA_BLOQUE_9'),
          permiso_bloque_10: this.$userIsInrol('BIODATA_BLOQUE_10'),
          permiso_bloque_11: this.$userIsInrol('BIODATA_BLOQUE_11'),
          permiso_bloque_12: this.$userIsInrol('BIODATA_BLOQUE_12'),
          permiso_bloque_13: this.$userIsInrol('BIODATA_BLOQUE_13'),
          permiso_bloque_14: this.$userIsInrol('BIODATA_BLOQUE_14'),
          permiso_bloque_15: this.$userIsInrol('BIODATA_BLOQUE_15')
        },
        politicState: true,
        personaSeleccioanda: '',
        loading: false,
        loadingPolitics: false,
        menuActivo: '',
        menu: {
          datosPersonales: 'DATOSPERSONALES',
          otrosdatosPersonales: 'OTROSDATOSPERSONALES',
          carguedocumentacion: 'CARGUEDOCUMENTACION',
          datosfamiliares: 'DATOSFAMILIARES',
          otrosdatosfamiliares: 'OTROSDATOSFAMILIARES',
          informacionacademica: 'INFORMACIONACADEMICA',
          referencias: 'REFERENCIAS',
          otrainformacionlaboral: 'OTRAINFORMACIONLABORAL',
          informacionbancaria: 'INFORMACIONBANCARIA',
          idiomaotrosestudios: 'IDIOMAOTROSESTUDIOS',
          informacionlaboral: 'INFORMACIONLABORAL',
          forularios: 'FORMULARIOS',
          cliente: 'CLIENTE',
          finalizacioningresodatos: 'FINALIZACIONINGRESODATOS',
          firmaDocumentos: 'FIRMAS'
        },
        form: this.$form.createForm(this, {
          name: 'frmBiotada'
        }),
        persona: {}
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.personaSeleccioanda = this.$store.state.userInfo.id_person
      this.menuActivo = this.menu.datosPersonales
    },
    methods: {
      statePolitics () {
        if (this.biodata_politicas_desactivadas || this.persona.acepta_politicas || this.puedeCrear === true ||
          JsUtils.isEmpty(this.$store.state.userInfo.id_person)) {
          this.isPoliticsVisible = false
        } else if (!this.persona.acepta_politicas && !this.$userIsInrol('Management')) {
          this.isPoliticsVisible = true
        }
      },
      changeStatePolitics () {
        this.loadingPolitics = true
        this.httpClient.getInstance().post('biodata/actualizar_politicas_empresa')
          .then(() => {
            this.isPoliticsVisible = false
            Mensajes.success('Correcto', 'Se registró correctamente.')
          })
          .catch(error => {
            let result = 'No fue posible registrar. Contacte al administrador.'
            if (!JsUtils.isEmpty(error.response)) {
              result = JsUtils.isEmpty(error.response.data) ? 'No fue posible registrar.' : error.response.data.message
            }
            Mensajes.error('Error', result)
          })
          .then(() => {
            this.loadingPolitics = false
          })
      },
      politicsChange (action) {
        if (action.target.checked === false) {
          this.politicState = true
        } else {
          this.politicState = false
        }
      },
      loadProfileData () {
        this.loading = true
        this.loadingParent = true

        this.httpClient.getInstance().get('picture_service/render/profile', {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })

        this.httpClient.getInstance().get('biodata/consultarDatosPersonales/' + this.personaSeleccioanda)
          .then(response => {
            this.personaCreada({
              ...response.data,
              nombre: response.data.name,
              identificacion: response.data.id_person
            })
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posble cargar los datos del resumen')
          })
          .then(() => {
            this.loading = false
            this.loadingParent = false
          })
      },
      personaCreada (person) {
        this.form.setFieldsValue({
          'identificacion': person.id_person
        })
        this.$refs.persona && this.$refs.persona.handleSearch(person.id_person)
        this.personaCambiada(person.id_person)
        this.persona = person
        this.statePolitics()
      },
      personaCambiada (identificacion) {
        this.personaSeleccioanda = identificacion
      },
      seleccionarMenu (e) {
        this.menuActivo = e.key
      }
    },
    watch: {
      personaSeleccioanda () {
        this.loadProfileData()
      }
    },
    computed: {
      puedeCrear () {
        return this.$userIsInrol('Biodata')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/Biodata.vue